/* ============================================================================
   PRESSROOM — Global header davranisi
   <pressroom-header> web component: mobil off-canvas drawer (ac/kapa, overlay,
   Escape, basit focus yonetimi). Desktop dropdown'lar native <details>.
   Cart drawer Dawn cart-drawer.js tarafindan id="cart-icon-bubble" ile yonetilir
   — burada DOKUNMUYORUZ (AJAX sepet bozulmaz).
   ============================================================================ */
(function () {
  'use strict';

  class PressroomHeader extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('[data-pr-burger]');
      this.drawer = this.querySelector('[data-pr-drawer]');
      if (!this.burger || !this.drawer) return;

      this.overlay = null;
      this._onKeydown = this._onKeydown.bind(this);

      this.burger.addEventListener('click', () => this.openDrawer());
      this.querySelectorAll('[data-pr-drawer-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.closeDrawer());
      });

      this._initHoverDropdowns();
    }

    /* Masaustu dropdown'lari HOVER'da acilsin, mouse cikinca kapansin (musteri
       istegi). pointer:fine + hover:hover cihazlarda; dokunmatikte native
       <details> tiklama davranisi korunur. Kucuk kapanis gecikmesi -> ust
       baslikla alt menu arasindaki bosluga inince kapanmaz. */
    _initHoverDropdowns() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var subs = this.querySelectorAll('.pr-header__sub');
      subs.forEach(function (d) {
        var t = null;
        var li = d.closest('.pr-header__menu-item');
        var host = li || d;
        host.addEventListener('mouseenter', function () { clearTimeout(t); d.open = true; });
        host.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { d.open = false; }, 140); });
        // summary tiklamasi sayfayi yeniden acmasin (hover zaten yonetiyor)
        var sum = d.querySelector('summary');
        if (sum) sum.addEventListener('click', function (e) { e.preventDefault(); });
      });
    }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      // overlay
      this.overlay = document.createElement('div');
      this.overlay.className = 'pr-header__overlay';
      this.overlay.addEventListener('click', () => this.closeDrawer());
      document.body.appendChild(this.overlay);
      // reflow -> transition
      void this.drawer.offsetWidth;
      requestAnimationFrame(() => {
        this.drawer.classList.add('is-open');
        if (this.overlay) this.overlay.classList.add('is-open');
      });
      this.burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKeydown);
      // ilk odaklanabilir elemana odaklan
      const firstLink = this.drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const finish = () => {
        this.drawer.hidden = true;
        if (this.overlay) {
          this.overlay.remove();
          this.overlay = null;
        }
      };
      if (reduce) {
        finish();
      } else {
        const onEnd = (e) => {
          if (e.target !== this.drawer) return;
          this.drawer.removeEventListener('transitionend', onEnd);
          finish();
        };
        this.drawer.addEventListener('transitionend', onEnd);
        // güvenlik: transition gelmezse
        setTimeout(finish, 600);
      }

      this.burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);
      this.burger.focus();
    }

    _onKeydown(e) {
      if (e.key === 'Escape') this.closeDrawer();
    }
  }

  if (!customElements.get('pressroom-header')) {
    customElements.define('pressroom-header', PressroomHeader);
  }
})();
